import { render, staticRenderFns } from "./setTemplate.vue?vue&type=template&id=2880cd99&scoped=true"
import script from "./setTemplate.vue?vue&type=script&lang=js"
export * from "./setTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880cd99",
  null
  
)

export default component.exports